import styled from "styled-components";
import { Button } from "antd";
import { COLORS } from "../../constants/colors";

export const StyledButton = styled(Button)`
    &&& {
        align-items: center;
        box-shadow: inset 0 0 0 #0000;
        display: flex;
        font-size: 16px;
        font-weight: 700;
        justify-content: center;
        overflow: hidden;
        transition: all 0.1s ease-in-out;
        height: 48px;
        width: 100%;
        background: radial-gradient(
            192.53% 172.33% at 0 0,
            #0288d1 38.54%,
            #51afe0 72.4%,
            #eaf9fe 99.48%
        );
        border-radius: 25px;
        color: ${COLORS.$white};
        line-height: 150%;
        padding: 0 16px;

        &:hover {
            align-items: center;
            background: radial-gradient(
                192.53% 172.33% at 0 0,
                #0288d1 38.54%,
                #51afe0 72.4%,
                #eaf9fe 99.48%
            );
            border-radius: 25px;
            border: 2px solid ${COLORS.$blueShades92};
            color: ${COLORS.$white};
            fontwight: 600;
        }
    }
`;

export const StyledGhostButton = styled(Button)`
    &&& {
        align-items: center;
        background: transparent;
        border-radius: 25px;
        border: 2px solid ${COLORS.$greyScale400};
        color: ${COLORS.$greyScale600};
        font-size: 16px;
        font-weight: 700;
        height: 48px;
        justify-content: center;
        line-height: normal;
        transition: all 0.3s ease-in-out;
        width: 100%;
        padding: 0 16px;
        display: flex;

        &.active {
            background: ${COLORS.$black};
            border: 2px solid ${COLORS.$black};
            color: ${COLORS.$white}!important;
        }

        &:hover {
            background: ${COLORS.$black};
            border: 2px solid ${COLORS.$black};
            color: ${COLORS.$white}!important;
        }
    }
`;

export const StyledEmojiButton = styled(Button)`
    &&& {
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: ${COLORS.$white};
        border: 2px solid ${COLORS.$lightBlue};
        border-radius: 8px;
        color: ${COLORS.$mainBlue};
        font-size: 16px;
        font-weight: 500;
        height: 47px;
        line-height: normal;
        transition: all 0.3s ease-in-out;
        padding: 0 16px;
        margin: 4px;
        width: auto;

        &:hover {
            background-color: ${COLORS.$black};
            border-color: ${COLORS.$black};
            color: ${COLORS.$white};
        }

        &.active {
            background-color: ${COLORS.$black};
            border-color: ${COLORS.$black};
            color: ${COLORS.$white};
        }

        span {
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 20px;
            margin-right: 8px;
        }
    }
`;
